export default __webpack_public_path__ + "static/media/dpdLocal-logo.79f19320.gif";